import { useQuery } from '@apollo/client';
import useDialog from 'hooks/useDialog';
import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import { GET_QUESTIONNAIRES } from 'graphql/secure/queries/questionnaire.queries';
import { useNavigate } from 'react-router-dom';
import { ECustomerPlan } from 'FeatureModules/Auth/types/company.types';
import { IQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';
import { IGraphQlConnection } from 'types/core.types';
import { removeGraphConnections } from 'utils/graphql.utils';

const useQuestionnaires = () => {
  const { data, loading, error } = useQuery<{ questionnaires: IGraphQlConnection<IQuestionnaire> }>(
    GET_QUESTIONNAIRES
  );
  const { plan } = useCompanyPlanContext();
  const navigate = useNavigate();
  const { openDialog } = useDialog();

  const isFreemium = plan === ECustomerPlan.FREEMIUM;

  const questionnaires = data?.questionnaires ? removeGraphConnections(data.questionnaires) : [];

  const handleQuestionnaireClick = (questionnaire: IQuestionnaire) => {
    if (isFreemium) {
      navigate(
        `/questionnaires/${questionnaire.id}/answers/${questionnaire.requestReceived.questionnaireCompanyResponseId}`
      );
    } else {
      navigate(`/questionnaires/${questionnaire.id}`);
    }
  };

  const handleCreateQuestionnaire = () => {
    openDialog({
      type: 'ADD_EDIT_QUESTIONNAIRE',
    });
  };

  const handleQuestionnaireEdit = (questionnaire: IQuestionnaire) => {
    openDialog({
      type: 'ADD_EDIT_QUESTIONNAIRE',
      props: {
        questionnaire,
        onQuestionnaireCreated: (createdQuestionnaire: IQuestionnaire) => {
          navigate(`/questionnaires/${createdQuestionnaire.id}`);
        },
      },
    });
  };

  return {
    questionnaires,
    loading,
    error,
    viewOnly: isFreemium,
    handleCreateQuestionnaire,
    handleQuestionnaireClick,
    handleQuestionnaireEdit,
  };
};

export default useQuestionnaires;
